import { Button, Row } from "antd";
import React, { FC, ReactNode, useEffect, useState } from "react";
import { http } from "../../helpers/http";
import { AxiosResponse } from "axios";
import "./Header.scss";

type User = {
  first_name?: string;
  last_name?: string;
  school?: {
    expired_credentials?: number;
  };
};

interface HeaderProps {
  title: string | React.ReactNode;
  counter?: number;
  button?: ReactNode;
}

export const Header: FC<HeaderProps> = ({ title, counter, button }) => {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    http.get("self")
      .then((res: AxiosResponse) => {
        setUser(res.data.data);
      })
      .catch((err) => {
        console.error("Failed to fetch user for header:", err);
      });
  }, []);

  const warningMessage =
    user?.school?.expired_credentials === 1
      ? "! CSDD API piekļuves dati ir beigušies !"
      : undefined;

  return (
    <Row className="header-row" justify="space-between" align="middle">
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <div style={{ fontWeight: "bold", display: "flex", alignItems: "center" }}>
          {title}
          {counter !== undefined && <b className="counter">{counter}</b>}
        </div>
        {warningMessage && (
          <span style={{ color: "red", fontWeight: "bold" }}>
            {warningMessage}
          </span>
        )}
      </div>
      {button}
    </Row>
  );
};